import React from 'react';
import PropTypes from 'prop-types';
import {
  TickSvg,
} from 'AppSrc/core/components/common/svg-icons';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';

const getSvgContainerSuffix = ({
  stepComplete,
  isCurrentStep,
  stepVisited,
}) => {
  if (isCurrentStep) { return 'current-step'; }
  if (stepComplete) { return 'complete'; }
  if (stepVisited) { return 'visited'; }
  return null;
};

const WorkFlowStage = React.memo(({
  workflowStageComponentData,
  stepComplete,
  isCurrentStep,
  stepVisited,
  name,
  canEdit,
  editAssignee,
}) => {
  const {
    statusId,
    header,
    svgIcon,
  } = workflowStageComponentData;

  const Svg = stepComplete ? TickSvg : svgIcon;

  const svgContainerSuffix = getSvgContainerSuffix({
    stepComplete,
    isCurrentStep,
    stepVisited,
  });

  const options = {
    statusId,
    editingName: name,
  };


  return (
    <li className="workflow-stage">
      <div className="workflow-stage-icon">
        <div className="workflow-stage-icon-border">
          <div
            className={`svg-container${svgContainerSuffix ? ` svg-container-${svgContainerSuffix}` : ''}`}
          >
            <Svg />
          </div>
        </div>
      </div>
      <h6 className="workflow-stage-header">
        {header}
      </h6>
      <h6 className="workflow-stage-name">
        {name}
      </h6>
      {
        canEdit && (
          <OptionButton
            className="edit-assigned-human"
            onClick={editAssignee}
            option={options}
          >
            <p className="edit-assigned-human-text">
              Edit
            </p>
          </OptionButton>
        )
      }
    </li>
  );
});

const workflowStageComponentDataShape = PropTypes.shape({
  statusId: PropTypes.string,
  header: PropTypes.string,
  svgIcon: PropTypes.elementType,
});

WorkFlowStage.propTypes = {
  workflowStageComponentData: workflowStageComponentDataShape,
  stepComplete: PropTypes.bool,
  isCurrentStep: PropTypes.bool,
  stepVisited: PropTypes.bool,
  name: PropTypes.string,
  canEdit: PropTypes.bool,
  editAssignee: PropTypes.func,
};


export { WorkFlowStage };
